// Components
import { DateInput, Input, Label, Textarea } from "components"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Third-Party Libraries
import moment from "moment"

// Utils
import { FormType } from "../utils"

export function FormSection(params: {
  date?: string
  disabled?: boolean
}): JSX.Element {
  // Vars
  const disabled = params.disabled

  // Form
  const { control } = useFormContext<FormType>()

  return (
    <table className="table">
      <tbody>
        <tr>
          <td>
            <Label text="DATE" />
          </td>

          <td>
            <DateInput
              disabled
              selected={params.date ? moment(params.date).toDate() : new Date()}
              onChange={() => {}}
            />
          </td>
        </tr>

        <Controller
          control={control}
          name="file_name"
          render={({ field, fieldState }) => (
            <tr>
              <td>
                <Label
                  text="FILE NAME"
                  error={Boolean(fieldState.error)}
                />
              </td>

              <td>
                <Input
                  {...field} 
                  placeholder="Input file name" 
                  disabled={disabled}
                  error={fieldState.error?.message}
                  value={field.value} 
                />
              </td>
            </tr>
          )}
        />

        <Controller
          control={control}
          name="description"
          render={({ field, fieldState }) => 
            <tr>
              <td>
                <Label
                  text="DESCRIPTION"
                  error={Boolean(fieldState.error)}
                />
              </td>

              <td>
                <Textarea
                  {...field} 
                  placeholder="Input Description"
                  disabled={disabled}
                  error={fieldState.error?.message}
                  value={field.value}
                />
              </td>
            </tr>
          }
        />
      </tbody>
    </table>
  )
}